import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type AppInfoState = {
	appVersion: string;
};

const defaultState: AppInfoState = {
	appVersion: "unknown",
};

export const appInfoState = atomWithStorage<AppInfoState>(
	"MYPLANN_APP_INFO_STATE",
	defaultState,
);

export const biometryEnabledState = atom(false);
